{
  "RESET_PASSWORD": {
    "TITLE": "Nollaa salasana",
    "DESCRIPTION": "Anna sähköpostiosoite, jolla kirjaudut yhteyskeskukseen, niin saat ohjeet salasanan vaihtamiseen.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Sähköposti",
      "PLACEHOLDER": "Ole hyvä ja syötä sähköpostiosoitteesi.",
      "ERROR": "Ole hyvä ja syötä validi sähköposti."
    },
    "API": {
      "SUCCESS_MESSAGE": "Salasanan palautuslinkki on lähetetty sähköpostiisi.",
      "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
    },
    "SUBMIT": "Lähetä"
  }
}
